export const DavidsBridalTopBar = require('./davids_light.svg');
export const DiamondTopBar = require('./diamond_loyalty_light.svg');
export const PearlTopBar = require('./Pearl_Launch_Logo_Black_On_Clear.png');
export const PearlBlack = require('./Pearl_Launch_Logo_Black_On_Clear.png');
export const PearlWhite = require('./PearlWhite.svg');
export const GoogleLogoImage = require('./google_on_white_hdpi.png');
